import { Loader } from 'google-maps';

import styles from '@/ui/mapstyles';

function GoogleMap({ node }) {
	const googleMapAPIKey = node.dataset.key;
	const loader = new Loader(googleMapAPIKey, {
		version: 'quarterly',
	});

	if (!googleMapAPIKey) node.remove();

	const maps = [...node.querySelectorAll('.js-map-new')];

	const loadMap = async mapDiv => {
		const google = await loader.load();

		const { latitude, longitude } = mapDiv.dataset;

		if (!latitude && !longitude) {
			node.remove();
			return;
		}

		const mapOptions = {
			zoom: 15,
			center: new google.maps.LatLng(latitude, longitude),
			styles,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			panControl: 1,
			zoomControl: true,
			scaleControl: false,
			mapTypeControl: false,
			streetViewControl: false,
			scrollwheel: false,
			draggable: true,
			disableDefaultUI: true,
		};

		const map = new google.maps.Map(mapDiv, mapOptions);

		const icon = {
			url: '/dist/img/svg/map-marker.svg',
			size: new google.maps.Size(50, 38),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(25, 18),
		};

		return new google.maps.Marker({
			map,
			position: new google.maps.LatLng(latitude, longitude),
			icon,
			draggable: false,
		});
	};

	maps.forEach(map => {
		loadMap(map);
	});
}

export default GoogleMap;
